import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

// firebase init - add your own config here
const firebaseConfig = {
  apiKey: "AIzaSyDMIRwWKwuMLftGFBUNEplH2XBQq1JX4fA",
  authDomain: "tradingif.firebaseapp.com",
  databaseURL: "https://tradingif.firebaseio.com",
  projectId: "tradingif",
  storageBucket: "tradingif.appspot.com",
  messagingSenderId: "282773508794",
  appId: "1:282773508794:web:135ff5fc40b5fabe8a6883",
  measurementId: "G-SF2KDBJ6JF"
}
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage

// collection references
const Users = db.collection('User')
const Accounts = db.collection('Account')
const Commands = db.collection('Command')
const Strategies = db.collection('Strategy')
const Subscriptions = db.collection('Subscription')
const Terminals = db.collection('Terminal')
const Plans = db.collection('Plan')
const Sales = db.collection('Sale')

// export utils/refs
export {
  db,
  auth,
  storage,
  Users,
  Accounts,
  Commands,
  Strategies,
  Subscriptions,
  Terminals,
  Plans,
  Sales
}